import Swiper, {
    Autoplay,
    Navigation,
    Pagination,
    Thumbs,
    FreeMode,
} from "swiper";
Swiper.use([Autoplay, Navigation, Pagination, Thumbs, FreeMode]);
window.Swiper = Swiper;
import imagesLoaded from "imagesloaded";
window.imagesLoaded = imagesLoaded;

// Auto visualizzate
const swiperVisualizzate = new Swiper(".swiperVisualizzate", {
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 15,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// Auto consigliate
const swiperConsigliate = new Swiper(".swiperConsigliate", {
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 15,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

/* Bottoni Garanzie su motore di ricerca */
const swiper_warranties_search_engine = new Swiper(
    ".swiper_warranties_search_engine",
    {
        // loop: true,
        spaceBetween: 10,
        autoplay: true,
        slidesPerView: 3,
        disableOnInteraction: true,
        speed: 900,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    }
);

/* NewsFlash */
const swiper_newsflash = imagesLoaded(".swiper_newsflash", function () {
    new Swiper(".swiper_newsflash", {
        loop: true,
        autoplay: true,
        speed: 1500,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            init: function () {
                var prevButton = this.navigation.$prevEl;
                var nextButton = this.navigation.$nextEl;

                $(prevButton).addClass("swiper-button-prev_white");
                $(nextButton).addClass("swiper-button-next_white");
            },
        },
    });
});

/* Homepage Banners */
const homepage_banners = imagesLoaded(".swiper-homepage_banners", function () {
    new Swiper(".swiper-homepage_banners", {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: true,
        delay: 4000,
        speed: 1000,
        mousewheel: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});

/* Best Offers */
const homepage_best_offers = imagesLoaded(
    ".swiper-homepage_best_offers",
    function () {
        new Swiper(".swiper-homepage_best_offers", {
            slidesPerView: 1,
            spaceBetween: 0,
            delay: 1850,
            speed: 500,
            mousewheel: true,
            autoplay: {
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            loop: true,
            breakpoints: {
                "@0.00": {
                    slidesPerView: 2,
                },
                "@0.75": {
                    slidesPerView: 2,
                },
                "@1.00": {
                    slidesPerView: 3,
                },
                "@1.50": {
                    slidesPerView: 4,
                },
            },
        });
    }
);

/* Auto in evidenza */
const homepage_auto_in_evidenza = imagesLoaded(
    ".swiper-homepage_auto_in_evidenza",
    function () {
        new Swiper(".swiper-homepage_auto_in_evidenza", {
            slidesPerView: 1,
            spaceBetween: 15,
            mousewheel: true,
            loop: true,
            delay: 2400,
            speed: 500,
            autoplay: true,
            breakpoints: {
                "@0.00": {
                    slidesPerView: 1,
                },
                "@0.75": {
                    slidesPerView: 2,
                },
                "@1.00": {
                    slidesPerView: 3,
                },
                "@1.50": {
                    slidesPerView: 5,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
);

/* Auto in arrivo */
const homepage_auto_in_arrivo = imagesLoaded(
    ".swiper-auto-in-arrivo",
    function () {
        new Swiper(".swiper-auto-in-arrivo", {
            slidesPerView: 1,
            spaceBetween: 0,
            mousewheel: true,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
);

/* Offerte del mese */
const homepage_offerte_del_msee = imagesLoaded(
    ".swiper-offerte-del-mese",
    function () {
        new Swiper(".swiper-offerte-del-mese", {
            slidesPerView: 1,
            spaceBetween: 10,
            mousewheel: true,
            loop: true,
            speed: 300,
            delay: 1500,
            autoplay: true,
            breakpoints: {
                "@0.00": {
                    slidesPerView: 1,
                },
                "@0.75": {
                    slidesPerView: 2,
                },
                "@1.00": {
                    slidesPerView: 3,
                },
                "@1.50": {
                    slidesPerView: 5,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
);

/* Scheda Gallery Full */
// swiper_scheda_full_thumbs deve essere posizionato prima di
// swiper_scheda_full
const swiper_scheda_full_thumbs = new Swiper(".swiper-scheda-thumbs", {
    loop: true,
    spaceBetween: 5,
    // slidesPerView: 5,
    freeMode: true,
    autoplay: true,
    speed: 1000,
    watchSlidesProgress: true,
    breakpoints: {
        "@0.00": {
            slidesPerView: 4,
        },
        "@0.75": {
            slidesPerView: 6,
        },
        "@1.00": {
            slidesPerView: 8,
        },
        "@1.50": {
            slidesPerView: 8,
        },
    },
});
const swiper_scheda_full = new Swiper(".swiper-scheda", {
    loop: true,
    spaceBetween: 0,
    // autoplay: true,
    // speed: 850,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiper_scheda_full_thumbs,
    },
});
/* Altre offerte nella scheda */
const altre_offerte = new Swiper(".swiper-altre-offerte", {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: true,
    delay: 1000,
    speed: 500,
    mousewheel: true,
    grabCursor: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        450: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 2,
            // spaceBetween: 20,
        },
        996: {
            slidesPerView: 3,
            // spaceBetween: 20,
        },
        1200: {
            slidesPerView: 4,
            // spaceBetween: 40,
        },
        1600: {
            slidesPerView: 5,
            // spaceBetween: 50,
        },
    },
});
/* Altre offerte nella lista */
const altre_offerte_lista = new Swiper(".swiper-altre-offerte-lista", {
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: true,
    delay: 1000,
    speed: 500,
    mousewheel: true,
    grabCursor: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 1,
            spaceBetween: 10,
        },
        "@0.75": {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        "@1.00": {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        "@1.50": {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    },
});
/* Altre offerte nella lista Preferiti */
const altre_offerte_lista_preferiti = new Swiper(
    ".swiper-altre-offerte-lista-preferiti",
    {
        slidesPerView: 6,
        spaceBetween: 0,
        autoplay: true,
        delay: 1000,
        speed: 500,
        mousewheel: true,
        grabCursor: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            "@0.00": {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            "@0.75": {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            "@1.00": {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            "@1.50": {
                slidesPerView: 6,
                spaceBetween: 10,
            },
        },
    }
);
/* Stock nelle landing */
const stock_landing = new Swiper(".swiper-stock-landing", {
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: true,
    speed: 850,
    loop: true,
    mousewheel: true,
    grabCursor: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 1,
            spaceBetween: 10,
        },
        "@0.75": {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // "@1.00": {
        //     slidesPerView: 3,
        //     spaceBetween: 40,
        // },
        "@1.50": {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    },
});
/* Slider Immagini Landing page */
const swiper_slider_landing = new Swiper(".swiper-slider-landing", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: true,
    speed: 500,
    loop: true,
    mousewheel: true,
    grabCursor: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    // breakpoints: {
    //     "@0.00": {
    //         slidesPerView: 1,
    //         spaceBetween: 10,
    //     },
    //     "@0.75": {
    //         slidesPerView: 2,
    //         spaceBetween: 20,
    //     },
    //     "@1.00": {
    //         slidesPerView: 3,
    //         spaceBetween: 40,
    //     },
    //     "@1.50": {
    //         slidesPerView: 5,
    //         spaceBetween: 50,
    //     },
    // },
});
/* Slider Video Youtube e Vimeo */
const video_landing = new Swiper(".swiper-video-landing", {
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: false,
    speed: 850,
    loop: true,
    mousewheel: true,
    grabCursor: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 1,
            spaceBetween: 40,
        },
        "@0.75": {
            slidesPerView: 1,
            spaceBetween: 40,
        },
        "@1.00": {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        "@1.50": {
            slidesPerView: 2,
            spaceBetween: 50,
        },
    },
});

const swiperBrands = new Swiper(".swiper-landing-brands", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: {
        delay: 10000,
    },
    speed: 850,
    loop: true,
    // mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 2, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        1024: { slidesPerView: 4, spaceBetween: 40 },
        1440: { slidesPerView: 6, spaceBetween: 10 },
    },
});

const swiperModels = new Swiper(".swiper-landing-models", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: {
        delay: 10000,
    },
    speed: 850,
    loop: true,
    // mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 2, spaceBetween: 40 },
        1440: { slidesPerView: 3, spaceBetween: 10 },
    },
});
